const social = {
  youtube: "https://www.youtube.com/channel/UCs1b6hGEjEl5lX3AMlDv6Gw",
  instagram: "https://www.instagram.com/6202band/",
  facebook: "https://www.facebook.com/The-6202-Band-202884267266500",
};

export default social;
